import { api } from "../services/api";

interface IConfig {
  apiClient?: {
    url?: string;
    authorization?: string;
  }
}

export function defineConfig({ apiClient }: IConfig) {
  if (apiClient) {
    const { authorization, url } = apiClient;

    if (url) api.defaults.baseURL = url;
    if (authorization) api.defaults.headers.common.Authorization = authorization;
  }
}
